import { config } from 'zod';

/**
 * v0.15a.3: zod builds fast object parsers with `new Function`, after trying once whether eval is allowed. The web
 * app's Content Security Policy allows no eval (script-src 'self'), so that try alone is a policy violation on every
 * page. Imported before any schema is made (the web app's first import), this keeps zod to its plain parsers.
 */
config({ jitless: true });
